import {ThemeSharedModule, ToasterService} from '@abp/ng.theme.shared';
import {ChangeDetectionStrategy, Component, inject, OnInit, signal} from '@angular/core';
import {GeneralSettingsService} from '@proxy/general-settings';
import {AccountSettingsService} from '@proxy/AccountSettings/accountSettings.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {
  NgbCollapseModule,
  NgbDatepickerModule,
  NgbDropdownModule,
} from '@ng-bootstrap/ng-bootstrap';
import { PageModule } from '@abp/ng.components/page';
import { CoreModule } from '@abp/ng.core';
import { CommercialUiModule } from '@shared/commercial-ui';

@Component({
    selector: 'app-general-settings',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './general-settings.component.html',
    styleUrls: ['./general-settings.component.css'],
    imports: [
        NgbCollapseModule,
        NgbDatepickerModule,
        NgbDropdownModule,
        PageModule,
        CoreModule,
        ThemeSharedModule,
        CommercialUiModule,
    ]
})
export class GeneralSettingsComponent implements OnInit {

  public readonly service = inject(AccountSettingsService);

  // A signal, not a plain field: set in a subscribe, which an OnPush ancestor does not redraw for
  // (#42). Replaces the detectChanges() workaround.
  readonly isLoading = signal(false);  // Loader flag
  companyInfoForm: FormGroup;

  constructor(
    private generalSettingsService: GeneralSettingsService,
    private toasterService: ToasterService,
    private fb: FormBuilder // Inject FormBuilder
  ) {
    // Initialize the form group
    this.companyInfoForm = this.fb.group({
      companyName: ['', Validators.required],
      address: ['', Validators.required],
      commercialRegistration: ['', Validators.required],
      taxNumber: ['', Validators.required],
      contactUsEmailReceiver: ['', [Validators.required, Validators.email]],
      claimsRetentionPeriod: ['', [Validators.required]],
      taqnyatSmsProviderToken: ['', [Validators.required]],
      taqnyatSmsProviderAlertLimit: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    this.loadCompanyInfo();
  }

  loadCompanyInfo(): void {
    this.isLoading.set(true);  // Start loader
    this.service.fetchSettings().subscribe({
      next: (res) => {
        // Update the form values using patchValue
        this.companyInfoForm.patchValue({
          companyName: res.companyName || '',
          address: res.address || '',
          commercialRegistration: res.commercialRegistration || '',
          taxNumber: res.taxNumber || '',
          contactUsEmailReceiver: res.contactUsEmailReceiver || '',
          claimsRetentionPeriod: res.claimsRetentionPeriod || '',
          taqnyatSmsProviderToken: res.taqnyatSmsProviderToken || '',
          taqnyatSmsProviderAlertLimit: res.taqnyatSmsProviderAlertLimit || '',
        });
        this.isLoading.set(false);  // Stop loader
      },
      error: (err) => {
        this.isLoading.set(false);  // Stop loader even in case of error
      }
    });
  }

  onSubmit(): void {
    if (this.companyInfoForm.valid) {
      // Use the form value instead of companyInfo
      this.service.updateCompanyInfo(this.companyInfoForm.value).subscribe(
        (res) => {
          // Handle success response
          this.toasterService.success('::SettingsUpdatedSuccess');
        },
      );
    } else {
      this.toasterService.error('::SettingsUpdatedFail');
    }
  }
}
